import { Container, HeaderTitle, SubmitButton, EventForm } from "./style";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { FormDataSource } from "../../util/formDataSource";
import { Left, Right } from "./style";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { addEvent, getEvent, updateEvent, uploadEventPromoBanner, deleteEventPromoBanner } from '../../api/eventsService';


interface Props {
  eventInputs: FormDataSource[];
  actionMode: string;
}
export type IUploadStatus = "NO_IMAGE" | "UPLOADING" | "UPLOADED";

const NewEvent: React.FC<Props> = ({ eventInputs, actionMode }) => {

  const { id }: any = useParams();
  const [file, setFile] = useState<File | null>(null);
  const [uploadStatus, setUploadStatus] = useState<IUploadStatus>("NO_IMAGE");
  const [data, setData]: any = useState({
    timeStamp: new Date(),
    image: `uploads/images/noimage.png`,
    currency: 'gbp',
  });
  const [promoLabels, setPromoLabels] = useState<string[]>(['', '', '']);
  /** Local blob URLs for file chosen before upload (per slot). */
  const [promoPreviewUrls, setPromoPreviewUrls] = useState<(string | null)[]>([null, null, null]);
  const [uploadingPromoSlot, setUploadingPromoSlot] = useState<number | null>(null);
  const promoFileRef0 = useRef<HTMLInputElement>(null);
  const promoFileRef1 = useRef<HTMLInputElement>(null);
  const promoFileRef2 = useRef<HTMLInputElement>(null);
  const promoFileRefs = [promoFileRef0, promoFileRef1, promoFileRef2];
  const promoPreviewUrlsRef = useRef<(string | null)[]>([null, null, null]);
  promoPreviewUrlsRef.current = promoPreviewUrls;
  const navigate = useNavigate();
  const currencys = [
    {
      name: 'GBP',
      value: 'gbp',
      label: '£'
    },
    {
      name: 'EUR',
      value: 'eur',
      label: '€'
    },
    {
      name: 'USD',
      value: 'usd',
      label: '$'
    }
  ];
  
  useEffect(() => {
   
  }, []);

  useEffect(() => {
    console.log(actionMode);
    if (actionMode == 'edit') {
      getEvent(id).then((item) => {
        setData(item);
      }).catch((err) => {
        console.log('error', err.message);
      })
    }
  }, [actionMode, id]);

  useEffect(() => {
    const banners = data?.meta?.promo_banners;
    if (!Array.isArray(banners)) {
      setPromoLabels(['', '', '']);
      return;
    }
    setPromoLabels([
      banners[0]?.label != null ? String(banners[0].label) : '',
      banners[1]?.label != null ? String(banners[1].label) : '',
      banners[2]?.label != null ? String(banners[2].label) : '',
    ]);
  }, [data?.meta?.promo_banners]);

  useEffect(() => {
    return () => {
      promoPreviewUrlsRef.current.forEach((u) => {
        if (u) URL.revokeObjectURL(u);
      });
    };
  }, []);

  const refreshEvent = async () => {
    if (actionMode !== 'edit' || !id) return;
    const item = await getEvent(id);
    if (item) setData(item);
  };

  const getPromoSlot = (slot: number) => {
    const b = data?.meta?.promo_banners;
    if (!Array.isArray(b) || !b[slot]?.url) return null;
    return b[slot];
  };

  const handlePromoLabelChange = (slot: number, value: string) => {
    setPromoLabels((prev) => {
      const next = [...prev];
      next[slot] = value;
      return next;
    });
  };

  const handlePromoFileChange = (slot: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    setPromoPreviewUrls((prev) => {
      const next = [...prev];
      if (next[slot]) {
        URL.revokeObjectURL(next[slot] as string);
        next[slot] = null;
      }
      if (f) {
        next[slot] = URL.createObjectURL(f);
      }
      return next;
    });
  };

  const clearPromoPreview = (slot: number) => {
    setPromoPreviewUrls((prev) => {
      const next = [...prev];
      if (next[slot]) {
        URL.revokeObjectURL(next[slot] as string);
        next[slot] = null;
      }
      return next;
    });
  };

  const handlePromoUpload = async (slot: number) => {
    const input = promoFileRefs[slot].current;
    const file = input?.files?.[0];
    if (!file) {
      window.alert('Please choose an image file first.');
      return;
    }
    try {
      setUploadingPromoSlot(slot);
      await uploadEventPromoBanner(id, slot, file, promoLabels[slot]);
      if (input) input.value = '';
      clearPromoPreview(slot);
      await refreshEvent();
    } catch (e: any) {
      window.alert(e?.message || 'Upload failed');
    } finally {
      setUploadingPromoSlot(null);
    }
  };

  const handlePromoDelete = async (slot: number) => {
    if (!window.confirm('Remove this promo banner?')) return;
    try {
      setUploadingPromoSlot(slot);
      await deleteEventPromoBanner(id, slot);
      clearPromoPreview(slot);
      if (promoFileRefs[slot].current) promoFileRefs[slot].current!.value = '';
      await refreshEvent();
    } catch (e: any) {
      window.alert(e?.message || 'Remove failed');
    } finally {
      setUploadingPromoSlot(null);
    }
  };

  const handlePromoRemoveClick = (slot: number) => {
    const entry = getPromoSlot(slot);
    const hasPreview = !!promoPreviewUrls[slot];
    if (hasPreview) {
      clearPromoPreview(slot);
      if (promoFileRefs[slot].current) promoFileRefs[slot].current!.value = '';
      return;
    }
    if (entry?.url) {
      void handlePromoDelete(slot);
    }
  };

  useEffect(() => {
    if (file) {
      setData({
        ...data,
        image: file.name,
        file: file
      });
      setUploadStatus("UPLOADED");
    }
  }, [file]);

  // handle form submiting
  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    // console.log('form data', data);
    let result = null;
    try {
      if (actionMode === 'edit') {
        result = await updateEvent(data);
      } else {
        result = await addEvent(data);
      }
      navigate('/events');

    } catch (error: any) {
      console.log(error.message);
    }

  };

  //handle image upload
  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setUploadStatus("UPLOADING");
    } else {
      setUploadStatus("NO_IMAGE");
    }
  };

  // handle form inputs
  const handleInput = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;
    setData({ ...data, [id]: value });
  };

  // JSX Return
  return (
    <Layout>
      <HeaderTitle>{actionMode === 'edit' ? 'Edit Event' : 'Add New Event'}</HeaderTitle>
      <Container
        style={
          actionMode === 'edit' && id
            ? { marginBottom: 12 }
            : undefined
        }
      >
        {/* Image upload */}
        <Left>
          <img
            src={
              file
                ? URL.createObjectURL(file)
                : `${process.env.REACT_APP_SERVER_URL}/api/${data.image}`
            }
            alt="img"
            className="img"
          />
        </Left>
        <Right>
          {/* Input form */}
          <EventForm
            onSubmit={(e) =>
              handleSubmit(e)
            }
          >
            <div className="file">
              <p className="inputTitle">Upload Image:</p>
              <label htmlFor="file">
                <DriveFolderUploadIcon className="icon" />
              </label>
            </div>
            <input
              onChange={handleFile}
              name="img"
              style={{ display: "none" }}
              type="file"
              id="file"
            />
            {/* Generating inputs from JSON */}
            {eventInputs.map((input) => (
              <div key={input.id} className="input">
                <label className="inputTitle">{input.label}</label>
                <br />
                <input
                  onChange={handleInput}
                  id={input.id}
                  className="inputField"
                  type={input.type}
                  placeholder={input.placeholder}
                  value={data[input.id]}
                  disabled={!input.label}
                />
              </div>
            ))}
            <div className="input">
              <label htmlFor="currency" className="inputTitle">Booth booking currency</label>
              <br />
              <select id="currency" className="inputField" value={data.currency || 'gbp'} onChange={handleInput}>
                {
                  currencys.map((item: any) => {
                    return (<option key={item.name} value={item.value}>{item.label} ({item.name})</option>)
                  })
                }
              </select>
            </div>
            <div className="full-width" style={{ marginTop: 8, marginBottom: 0 }}>
              <p className="inputTitle" style={{ fontWeight: 600, marginBottom: 4 }}>Product orders (furniture, electrics, AV)</p>
              <p style={{ fontSize: 13, color: '#666', margin: 0 }}>
                Optional. Leave blank to use the same tax and currency as booth booking.
              </p>
            </div>
            <div className="input">
              <label htmlFor="product_tax" className="inputTitle">Product order tax (%)</label>
              <br />
              <input
                onChange={handleInput}
                id="product_tax"
                className="inputField"
                type="number"
                min={0}
                placeholder="Same as booth booking"
                value={data.product_tax ?? ''}
              />
            </div>
            <div className="input">
              <label htmlFor="product_currency" className="inputTitle">Product order currency</label>
              <br />
              <select
                id="product_currency"
                className="inputField"
                value={data.product_currency || ''}
                onChange={handleInput}
              >
                <option value="">Same as booth booking</option>
                {
                  currencys.map((item: any) => (
                    <option key={`product-${item.name}`} value={item.value}>{item.label} ({item.name})</option>
                  ))
                }
              </select>
            </div>
            {/* <div className="input">
              <label htmlFor="status" className="inputTitle">Status</label>
              <br />
              <select id="status" className="inputField" value={data.status} onChange={handleInput}>
                <option value="-1">Select Status</option>
                {
                  status.map((item: any) => {
                    return (<option key={item.id} value={item.id}>{item.name}</option>)
                  })
                }
              </select>
            </div> */}
            <div className="full-width">
              <label className="inputTitle">{"Booth Booking Terms & Conditions"}</label>
              <br />
              <textarea
                onChange={handleInput}
                id={'terms_and_conditions'}
                className="termsAndConditionsField"
                placeholder={"Input Terms and Conditions"}
                value={data['terms_and_conditions']}
                rows={5}
              />
            </div>
            {uploadStatus === "UPLOADING" ? (
              <SubmitButton disabled type="submit">
                Uploading...
              </SubmitButton>
            ) : (
              <SubmitButton type="submit">SUBMIT</SubmitButton>
            )}
          </EventForm>
        </Right>
      </Container>

      {actionMode === 'edit' && id && (
        <Container
          style={{
            marginTop: 0,
            paddingTop: 20,
            marginBottom: 120,
          }}
        >
          <h3 style={{ width: '100%', marginBottom: 8, fontSize: 18, fontWeight: 600 }}>
            Exhibiting resources — promo banners
          </h3>
          <p style={{ width: '100%', fontSize: 14, color: '#666', marginBottom: 20 }}>
            Optional: up to 3 images per event (slots 1–3). JPEG, PNG, GIF, or WebP, max 5 MB each.
            Stored on the event for exhibitor download (exhibitor UI can be wired separately).
          </p>
          {[0, 1, 2].map((slot) => {
            const entry = getPromoSlot(slot);
            const busy = uploadingPromoSlot === slot;
            const previewUrl = promoPreviewUrls[slot];
            const displaySrc = previewUrl
              ? previewUrl
              : entry?.url
                ? `${process.env.REACT_APP_SERVER_URL}/api/${entry.url}`
                : null;
            return (
              <div
                key={slot}
                style={{
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  padding: '12px 16px',
                  marginBottom: 16,
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: 16,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 12,
                    flexShrink: 0,
                  }}
                >
                  <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>Slot {slot + 1}</span>
                  {displaySrc && (
                    <img
                      src={displaySrc}
                      alt=""
                      style={{
                        width: 120,
                        height: 72,
                        objectFit: 'contain',
                        background: '#f5f5f5',
                        borderRadius: 4,
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    flex: 1,
                    minWidth: 200,
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 12,
                  }}
                >
                  <div style={{ flex: '1 1 160px', minWidth: 120 }}>
                    <label className="inputTitle">Label (optional)</label>
                    <input
                      className="inputField"
                      style={{ width: '100%', marginTop: 4, display: 'block' }}
                      value={promoLabels[slot]}
                      onChange={(e) => handlePromoLabelChange(slot, e.target.value)}
                      placeholder="e.g. LinkedIn 1200×628"
                    />
                  </div>
                  <input
                    ref={promoFileRefs[slot]}
                    type="file"
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    style={{ flex: '0 0 auto', alignSelf: 'center' }}
                    onChange={(e) => handlePromoFileChange(slot, e)}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 8,
                      flexShrink: 0,
                      flex: '0 0 auto',
                    }}
                  >
                    <SubmitButton
                      type="button"
                      onClick={() => handlePromoUpload(slot)}
                      disabled={busy}
                      style={{ width: 'auto', minWidth: 140, flex: '0 0 auto' }}
                    >
                      {busy ? 'Working…' : 'Upload'}
                    </SubmitButton>
                    {(previewUrl || entry?.url) && (
                      <SubmitButton
                        type="button"
                        onClick={() => handlePromoRemoveClick(slot)}
                        disabled={busy}
                        style={{ width: 'auto', minWidth: 140, flex: '0 0 auto' }}
                      >
                        Remove
                      </SubmitButton>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </Container>
      )}
    </Layout>
  );
};

export default NewEvent;
